import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Badge,
  Spinner,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  FormGroup,
  Progress,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import "./table.css";

import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

import s from "./Tables.module.scss";

import {
  API_TIMEOUT,
  FAKTUR_PERMINTAAN_BY_TUJUAN,
  DOMAIN_SIMOBAT,
  PERMINTAAN,
  KELUAR_MASUK,
  KELUAR_MASUK_UNIT,
  LOKASI,
} from "../../utils/index.js";
import axios from "axios";

import { formatDate, logApp, numberWithCommas } from "../../utils/func.js";

const TableOrder = function () {
  const [firstTable, setFirstTable] = useState([]);
  const [allData, setAllData] = useState([]);
  const [firstTableCurrentPage, setFirstTableCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState();
  const [idLokasi, setIdLokasi] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  // State untuk modal detail
  const [modalDetail, setModalDetail] = useState(false);
  const [secondTable, setSecondTable] = useState([]);
  const [tabelSementara, setTableSementara] = useState([]);
  const [fakturPermintaan, setFakturPermintaan] = useState([]);
  const [fakturKeluar, setFakturKeluar] = useState("");
  const [level, setLevel] = useState("");
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setCurrentUser(user);
      setIdLokasi(user.idLokasi);
      logApp(user.uid, "Order");
    }
  }, []);

  useEffect(() => {
    if (idLokasi) {
      ambilDataOrder();
      ambilDataLokasi();
    }
  }, [idLokasi]);

  // useEffect untuk getMasuk dihapus, akan dipanggil langsung dari getFakturMinta

  const ambilDataOrder = () => {
    if (!idLokasi) {
      return;
    }
    setLoading(true);
    axios({
      method: "get",
      url: FAKTUR_PERMINTAAN_BY_TUJUAN + idLokasi,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          setLoading(false);
          return "error";
        } else {
          const data = response.data.data;
          setAllData(data);
          setFirstTable(data);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error mengambil data order:", error);
        alert("Gagal mengambil data order");
      });
  };

  const ambilDataLokasi = () => {
    axios({
      method: "get",
      url: LOKASI + "ambil/",
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          return "error";
        } else {
          const data = response.data.data;
          if (data.length > 0) {
            const fil = data.filter((item) => {
              return idLokasi == item.id;
            });

            if (fil.length > 0) {
              const levelData = fil[0].level;
              setLevel(levelData);
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error mengambil data lokasi:", error);
      });
  };

  const getMasuk = (faktur, permintaanData) => {
    // Jika tidak ada faktur keluar atau faktur kosong, langsung set data permintaan saja
    if (!faktur || faktur === "" || faktur === null || faktur === undefined) {
      setSecondTable(permintaanData || []);
      return;
    }
    axios({
      method: "get",
      url: (level == "Dinas" ? KELUAR_MASUK : KELUAR_MASUK_UNIT) + faktur,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // Jika error, tetap tampilkan data permintaan
          console.log(
            "Response status tidak 200, tampilkan data permintaan saja"
          );
          setSecondTable(permintaanData || []);
          return "error";
        } else {
          const responseData =
            response.data && response.data.data ? response.data.data : [];
          console.log("Data masuk:", responseData);
          setTableSementara(responseData);
          const tabelSementara = responseData;

          // Gunakan data permintaan yang sudah diambil
          const data = [...(permintaanData || [])];

          for (let i = 0; i < data.length; i++) {
            const dataobat = tabelSementara.filter((itemKu) => {
              return data[i].id_dataObat == itemKu.id_dataObat;
            });

            if (dataobat.length > 0) {
              data[i] = {
                ...data[i],
                ...dataobat[0],
              };
            }
          }
          console.log("Data gabungan:", data);
          setSecondTable(data);
        }
      })
      .catch((error) => {
        console.error("Error mengambil data masuk:", error);
        // Jika error, tetap tampilkan data permintaan
        setSecondTable(permintaanData);
      });
  };

  const getFakturMinta = (noFaktur, fakturKeluarValue) => {
    axios({
      method: "get",
      url: PERMINTAAN + noFaktur,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          console.error("Response status tidak 200:", response.status);
          setSecondTable([]);
          return "error";
        } else {
          const permintaanData =
            response.data && response.data.data ? response.data.data : [];
          console.log("Data permintaan:", permintaanData);
          setFakturPermintaan(permintaanData);

          // Langsung panggil getMasuk dengan data yang sudah diambil
          getMasuk(fakturKeluarValue, permintaanData);
        }
      })
      .catch((error) => {
        console.error("Error mengambil faktur permintaan:", error);
        setSecondTable([]);
        alert("Gagal mengambil data faktur permintaan");
      });
  };

  const handleOpenModalPermintaan = (item) => {
    getFakturMinta(item.noFaktur, item.fakturKeluar);
  };

  const openModal = (data) => {
    setFakturKeluar(data.fakturKeluar);
    setSecondTableCurrentPage(0);
    setModalDetail(true);
    // Reset data sebelumnya
    setSecondTable([]);
    setFakturPermintaan([]);
    setTableSementara([]);
    // Panggil fungsi untuk mengambil data
    handleOpenModalPermintaan(data);
  };

  const closeModal = () => {
    setFakturPermintaan([]);
    setTableSementara([]);
    setSecondTable([]);
    setModalDetail(false);
  };

  const pageSize = 10;
  const pageSize2 = 100;
  const firstTablePagesCount = Math.ceil(firstTable.length / pageSize);
  const secondTablePagesCount = Math.ceil(secondTable.length / pageSize2);

  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  };

  const setFirstTablePage = (e, index) => {
    e.preventDefault();
    setFirstTableCurrentPage(index);
  };

  const searchItems = (e) => {
    const src = e.target.value;
    setSearchTerm(src);
    setFirstTableCurrentPage(0); // Reset ke halaman pertama saat search

    if (src === "") {
      setFirstTable(allData);
    } else {
      const filteredItems = allData.filter((item) => {
        const noFaktur = item.noFaktur ? item.noFaktur.toUpperCase() : "";
        const lokasiAsal = item.lokasi_asal
          ? item.lokasi_asal.toUpperCase()
          : "";
        const searchUpper = src.toUpperCase();

        return (
          noFaktur.includes(searchUpper) || lokasiAsal.includes(searchUpper)
        );
      });
      setFirstTable(filteredItems);
    }
  };

  const getStatusBadge = (status) => {
    // Handle berbagai tipe data status (number, string, null, undefined)
    if (status === null || status === undefined) {
      return <Badge color="warning">Belum Direspon</Badge>;
    }

    const statusNum = parseInt(status, 10);

    if (isNaN(statusNum) || statusNum === 0) {
      return <Badge color="warning">Belum Direspon</Badge>;
    } else {
      return <Badge color="success">Sudah Direspon</Badge>;
    }
  };

  const getFileName = () => {
    const now = new Date();
    const tanggal = now.toISOString().split("T")[0].replace(/-/g, "");
    return `Order_${tanggal}`;
  };

  const exportToExcel = () => {
    const table = document.getElementById("table_order");
    if (!table) {
      alert("Tabel tidak ditemukan");
      return;
    }

    const wb = XLSX.utils.table_to_book(table, { sheet: "Data" });
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, getFileName() + ".xlsx");
  };

  const exportToPDF = () => {
    const table = document.getElementById("table_order");
    if (!table) {
      alert("Tabel tidak ditemukan");
      return;
    }

    const doc = new jsPDF();
    doc.text("Daftar Order", 14, 15);
    doc.text(`Tanggal Export: ${formatDate(new Date())}`, 14, 22);

    const tableData = [];
    const headers = [];

    const thead = table.querySelector("thead");
    if (thead) {
      const headerRows = thead.querySelectorAll("tr");
      headerRows.forEach((row) => {
        const rowData = [];
        row.querySelectorAll("th").forEach((th) => {
          const text = th.textContent.trim();
          if (text) {
            rowData.push(text);
          }
        });
        if (rowData.length > 0) {
          headers.push(rowData);
        }
      });
    }

    const tbody = table.querySelector("tbody");
    if (tbody) {
      tbody.querySelectorAll("tr").forEach((row) => {
        const rowData = [];
        row.querySelectorAll("td").forEach((td) => {
          const text = td.textContent.trim();
          rowData.push(text);
        });
        if (rowData.length > 0) {
          tableData.push(rowData);
        }
      });
    }

    if (headers.length > 0 && tableData.length > 0) {
      doc.autoTable({
        head: headers,
        body: tableData,
        startY: 30,
      });
    }

    doc.save(getFileName() + ".pdf");
  };

  return (
    <div>
      <Row>
        <Col>
          <Widget className="widget-p-md">
            <div className="headline-2">Daftar Order</div>
            <div className="mt-2 mb-3 body-3 muted">
              Daftar permintaan obat yang masuk ke lokasi Anda
            </div>

            <FormGroup className="mb-3">
              <InputGroup>
                <Input
                  type="text"
                  placeholder="Cari berdasarkan nomor faktur atau lokasi asal..."
                  value={searchTerm}
                  onChange={searchItems}
                />
                <InputGroupAddon addonType="append">
                  <Button color="default">
                    <i className="fa fa-search" />
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>

            <div className="d-flex justify-content-between mb-3">
              <div>
                <button
                  className="btn btn-primary"
                  onClick={ambilDataOrder}
                  disabled={loading}
                >
                  <i className="fa fa-refresh mr-2" />
                  Refresh
                </button>
              </div>
              <div>
                <button
                  className="btn btn-success mr-2"
                  onClick={exportToExcel}
                  disabled={loading || firstTable.length === 0}
                  style={{ height: "32px", padding: "0.25rem 0.75rem" }}
                >
                  <i className="fa fa-file-excel-o mr-2" />
                  Excel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={exportToPDF}
                  disabled={loading || firstTable.length === 0}
                  style={{ height: "32px", padding: "0.25rem 0.75rem" }}
                >
                  <i className="fa fa-file-pdf-o mr-2" />
                  PDF
                </button>
              </div>
            </div>

            {loading ? (
              <div className="text-center py-5">
                <Spinner color="primary" />
                <p className="mt-2">Memuat data...</p>
              </div>
            ) : (
              <div className="widget-table-overflow">
                <Table
                  id="table_order"
                  className={`table-striped table-borderless table-hover ${s.statesTable}`}
                  responsive
                >
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>No Faktur</th>
                      <th>Tanggal</th>
                      <th>Lokasi Asal</th>
                      <th>Jumlah Obat</th>
                      <th>Petugas</th>
                      <th>Petugas Respon</th>
                      <th>Status</th>
                      <th>Tanggal Respon</th>
                      <th>AKOMODIR</th>
                      <th>Catatan</th>
                      <th>File Surat</th>
                      <th>Detail</th>
                    </tr>
                  </thead>
                  <tbody>
                    {firstTable.length === 0 ? (
                      <tr>
                        <td colSpan="14" className="text-center py-4">
                          <p className="text-muted">Tidak ada data order</p>
                        </td>
                      </tr>
                    ) : (
                      firstTable
                        .slice(
                          firstTableCurrentPage * pageSize,
                          (firstTableCurrentPage + 1) * pageSize
                        )
                        .map((item, index) => (
                          <tr key={uuidv4()}>
                            <td>
                              {firstTableCurrentPage * pageSize + index + 1}
                            </td>
                            <td>
                              <code>{item.noFaktur}</code>
                            </td>
                            <td>{formatDate(item.tanggal)}</td>
                            <td>{item.lokasi_asal || "-"}</td>
                            <td>{numberWithCommas(item.jumlahObat)}</td>
                            <td>{item.petugas_nama || "-"}</td>
                            <td>{item.petugas2_nama || "-"}</td>
                            <td>
                              {(() => {
                                const statusValue =
                                  item.status !== undefined &&
                                  item.status !== null
                                    ? item.status
                                    : 0;
                                const statusNum = parseInt(statusValue, 10);

                                if (isNaN(statusNum) || statusNum === 0) {
                                  return (
                                    <Badge color="warning">
                                      Belum Direspon
                                    </Badge>
                                  );
                                } else {
                                  return (
                                    <Badge color="success">
                                      Sudah Direspon
                                    </Badge>
                                  );
                                }
                              })()}
                            </td>
                            <td>
                              {item.tanggalRes
                                ? formatDate(item.tanggalRes)
                                : "-"}
                            </td>
                            <td>
                              <div className={`d-flex justify-content-between`}>
                                <div className="d-flex flex-column mt-3">
                                  <div className={s.activity}>
                                    <p className="body-2">
                                      {item.jumlahObatKeluar
                                        ? Math.round(
                                            (item.jumlahObat /
                                              item.jumlahObatKeluar) *
                                              100
                                          )
                                        : 0}
                                      % akomodir{" "}
                                    </p>
                                    <p className="body-2">
                                      {item.jumlahObat || 0}
                                      <span className="body-3 muted">
                                        /{item.jumlahObatKeluar || 0}
                                      </span>
                                    </p>
                                  </div>
                                  <Progress
                                    color={
                                      item.jumlahObatKeluar &&
                                      (item.jumlahObat /
                                        item.jumlahObatKeluar) *
                                        100 >
                                        50
                                        ? "success"
                                        : "danger"
                                    }
                                    className="progress-xs"
                                    value={
                                      item.jumlahObatKeluar
                                        ? (item.jumlahObat /
                                            item.jumlahObatKeluar) *
                                          100
                                        : 0
                                    }
                                  />
                                </div>
                              </div>
                            </td>
                            <td>
                              {item.catatan ? (
                                <span
                                  title={item.catatan}
                                  style={{
                                    display: "inline-block",
                                    maxWidth: "200px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {item.catatan}
                                </span>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              {item.file && item.file !== "-" ? (
                                <Button
                                  color="info"
                                  size="sm"
                                  onClick={() => {
                                    window.open(
                                      DOMAIN_SIMOBAT + item.file,
                                      "_blank"
                                    );
                                  }}
                                  title="Buka file surat"
                                >
                                  <i className="fa fa-file-pdf-o" />
                                </Button>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              <Button
                                className={`${s.controlBtn} mx-2`}
                                color="primary"
                                size="xs"
                                onClick={() => {
                                  openModal(item);
                                }}
                              >
                                Data
                              </Button>
                            </td>
                          </tr>
                        ))
                    )}
                  </tbody>
                </Table>
                {firstTable.length > 0 && (
                  <Pagination
                    className="pagination-borderless"
                    aria-label="Page navigation example"
                  >
                    <PaginationItem disabled={firstTableCurrentPage <= 0}>
                      <PaginationLink
                        onClick={(e) =>
                          setFirstTablePage(e, firstTableCurrentPage - 1)
                        }
                        previous
                        href="#top"
                      />
                    </PaginationItem>
                    {[...Array(firstTablePagesCount)].map((page, i) => (
                      <PaginationItem
                        active={i === firstTableCurrentPage}
                        key={i}
                      >
                        <PaginationLink
                          onClick={(e) => setFirstTablePage(e, i)}
                          href="#top"
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem
                      disabled={
                        firstTableCurrentPage >= firstTablePagesCount - 1
                      }
                    >
                      <PaginationLink
                        onClick={(e) =>
                          setFirstTablePage(e, firstTableCurrentPage + 1)
                        }
                        next
                        href="#top"
                      />
                    </PaginationItem>
                  </Pagination>
                )}
              </div>
            )}
          </Widget>
        </Col>
      </Row>

      <Modal size="lg" isOpen={modalDetail} toggle={() => closeModal()}>
        <ModalHeader toggle={() => closeModal()}>
          <div className={s.tableTitle}>
            <div className="headline-2">
              Daftar Obat Minta
              <code> Vs</code> Response
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <Widget className="widget-p-md">
            <div className="widget-table-overflow">
              <Table
                id="dataBantuan"
                className={`table-striped table-borderless table-hover ${s.statesTable}`}
                responsive
              >
                <thead>
                  <tr>
                    <th className={s.checkboxCol}>
                      <div className="checkbox checkbox-primary">
                        <input
                          className="styled"
                          id="checkbox100"
                          type="checkbox"
                        />
                        <label htmlFor="checkbox100" />
                      </div>
                    </th>
                    <th className="w-25">Obat</th>
                    <th className="w-25">Satuan</th>
                    <th className="w-25">Permintaan</th>
                    <th className="w-25">Dikirim</th>
                    <th className="w-25">Akomodir</th>
                  </tr>
                </thead>
                <tbody>
                  {secondTable.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        <p className="text-muted">Tidak ada data detail</p>
                      </td>
                    </tr>
                  ) : (
                    secondTable
                      .slice(
                        secondTableCurrentPage * pageSize2,
                        (secondTableCurrentPage + 1) * pageSize2
                      )
                      .map((item) => (
                        <tr key={uuidv4()}>
                          <td>
                            <div className="checkbox checkbox-primary">
                              <input
                                id={item.nama}
                                className="styled"
                                type="checkbox"
                              />
                              <Label htmlFor={item.nama} />
                            </div>
                          </td>
                          <td className="d-flex align-items-center">
                            <span className="ml-3">{item.nama}</span>
                          </td>
                          <td>{item.satuan}</td>
                          <td>
                            {item.jumlahMinta &&
                              numberWithCommas(item.jumlahMinta)}
                          </td>
                          <td>
                            {item.jumlahMasuk &&
                              numberWithCommas(item.jumlahMasuk)}
                          </td>
                          <td>
                            <div className={`d-flex justify-content-between`}>
                              <div className="d-flex flex-column mt-3">
                                <div className={s.activity}>
                                  <p className="body-2">
                                    {item.jumlahMasuk
                                      ? Math.round(
                                          (item.jumlahMasuk /
                                            item.jumlahMinta) *
                                            100
                                        )
                                      : 0}
                                    % akomodir{" "}
                                  </p>
                                  <p className="body-2">
                                    {item.jumlahMasuk ? item.jumlahMasuk : 0}
                                    <span className="body-3 muted">
                                      /{item.jumlahMinta}
                                    </span>
                                  </p>
                                </div>
                                <Progress
                                  color={
                                    item.jumlahMasuk &&
                                    (item.jumlahMasuk / item.jumlahMinta) *
                                      100 >
                                      50
                                      ? "success"
                                      : "danger"
                                  }
                                  className="progress-xs"
                                  value={
                                    item.jumlahMasuk
                                      ? (item.jumlahMasuk / item.jumlahMinta) *
                                        100
                                      : 0
                                  }
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                  )}
                </tbody>
              </Table>
              {secondTable.length > 0 && (
                <Pagination
                  className="pagination-borderless"
                  aria-label="Page navigation example"
                >
                  <PaginationItem disabled={secondTableCurrentPage <= 0}>
                    <PaginationLink
                      onClick={(e) =>
                        setSecondTablePage(e, secondTableCurrentPage - 1)
                      }
                      previous
                      href="#top"
                    />
                  </PaginationItem>
                  {[...Array(secondTablePagesCount)].map((page, i) => (
                    <PaginationItem
                      active={i === secondTableCurrentPage}
                      key={i}
                    >
                      <PaginationLink
                        onClick={(e) => setSecondTablePage(e, i)}
                        href="#top"
                      >
                        {i + 1}
                      </PaginationLink>
                    </PaginationItem>
                  ))}
                  <PaginationItem
                    disabled={
                      secondTableCurrentPage >= secondTablePagesCount - 1
                    }
                  >
                    <PaginationLink
                      onClick={(e) =>
                        setSecondTablePage(e, secondTableCurrentPage + 1)
                      }
                      next
                      href="#top"
                    />
                  </PaginationItem>
                </Pagination>
              )}
            </div>
          </Widget>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default TableOrder;
